import { useSelector, shallowEqual } from "react-redux";
import BookingBannerPlaceholder from "app/pages/Booking/BookingBannerPlaceholder/BookingBannerPlaceholder";
import {
	checkForSpecialOffer,
	checkSpecialOfferForSelectedDepartureDate,
} from "app/pages/Booking/Payment/paymentSelector";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import withRouter from "app/utils/hocs/withRouter";

const mapStateToProps = (state, ownProps) => {
	const { location } = ownProps;

	const shouldConsiderFlightSpecialOffer = ["payment", "quote", "detail"].find(page => {
		return location.pathname.includes(page);
	});

	return {
		specialOffer: state.ficheProduit.specialOffer,
		fallBackSpecialOffer: state.partner.fallbackSpecialOffer,
		isSpecialOfferActive: shouldConsiderFlightSpecialOffer
			? checkForSpecialOffer(state)
			: checkSpecialOfferForSelectedDepartureDate(state),
		userIsConnected: isAuthenticated(state),
	};
};

const BookingBannerPlaceholderContainer = props => {
	const stateProps = useSelector(state => mapStateToProps(state, props), shallowEqual);
	return <BookingBannerPlaceholder {...props} {...stateProps} />;
};

export default withRouter(BookingBannerPlaceholderContainer);
